// Question Type Constants
export const QUESTION_TYPES = {
  MCQ_SINGLE_CORRECT: 'MCQ-SC4',
  MCQ_MULTIPLE_CORRECT: 'MCQ-MC4',
  TRUE_FALSE: 'TF',
  FILL_IN_BLANK: 'FIB',
  SUBJECTIVE: 'SUB',
} as const;

// Only these question types should be shown to the user
export const ALLOWED_QUESTION_TYPES: string[] = [
  QUESTION_TYPES.MCQ_SINGLE_CORRECT,
  QUESTION_TYPES.MCQ_MULTIPLE_CORRECT,
  QUESTION_TYPES.TRUE_FALSE,
  QUESTION_TYPES.FILL_IN_BLANK,
  QUESTION_TYPES.SUBJECTIVE,
];

// Question Status Constants
export const QUESTION_STATUS = {
  VISITED: 'visited',
  SAVED: 'saved',
  MARK_FOR_REVIEW: 'mark_for_review',
  SAVE_AND_MARK_FOR_REVIEW: 'save_and_mark_for_review',
} as const;

export type QuestionType = (typeof QUESTION_TYPES)[keyof typeof QUESTION_TYPES];
export type QuestionStatus = (typeof QUESTION_STATUS)[keyof typeof QUESTION_STATUS];
